import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

import { toJalaliFullDate } from "../../../middleware/middleware";

const ProcessOperationOwnerField = ({
  label = "مسئول فرآیند",
  experts = [],
  assignedToUserId = "",
  assignedToFullName = "",
  assignedAt = null,
  canEdit = false,
  saving = false,
  onAssigneeChange,
}) => {
  const selectValue =
    assignedToUserId === null ||
    assignedToUserId === undefined ||
    assignedToUserId === ""
      ? ""
      : String(assignedToUserId);

  const displayName =
    assignedToFullName ||
    experts.find((e) => String(e.id ?? e.Id) === selectValue)?.fullName ||
    experts.find((e) => String(e.id ?? e.Id) === selectValue)?.FullName ||
    (selectValue ? "کارشناس" : "—");

  if (!canEdit) {
    return (
      <Box sx={{ py: 0.5 }}>
        <Typography variant="caption" color="text.secondary" display="block">
          {label}
        </Typography>
        <Typography variant="body2">{displayName}</Typography>
        {assignedAt ? (
          <Typography variant="caption" color="text.secondary">
            از {toJalaliFullDate(assignedAt) || "—"}
          </Typography>
        ) : null}
      </Box>
    );
  }

  return (
    <FormControl fullWidth size="small" disabled={saving}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={selectValue}
        onChange={(e) => {
          const v = e.target.value;
          onAssigneeChange(v === "" ? null : Number(v));
        }}
      >
        <MenuItem value="">بدون مسئول</MenuItem>
        {experts.map((u) => (
          <MenuItem key={u.id ?? u.Id} value={String(u.id ?? u.Id)}>
            {u.fullName ?? u.FullName}
          </MenuItem>
        ))}
      </Select>
      {assignedAt ? (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
          آخرین تخصیص: {toJalaliFullDate(assignedAt) || "—"}
        </Typography>
      ) : null}
    </FormControl>
  );
};

ProcessOperationOwnerField.propTypes = {
  label: PropTypes.string,
  experts: PropTypes.array,
  assignedToUserId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  assignedToFullName: PropTypes.string,
  assignedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  canEdit: PropTypes.bool,
  saving: PropTypes.bool,
  onAssigneeChange: PropTypes.func,
};

export default ProcessOperationOwnerField;
